var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Main",
    { attrs: { pageClass: "narrow-ui" } },
    [
      _c("h1", [_vm._v("Quote")]),
      _vm._v(" "),
      _c("b-card", [
        _c("h2", { staticClass: "step-title" }, [_vm._v("Destination")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-wrapper" },
          [
            _c("b-form-input", {
              attrs: {
                id: "addressInput",
                size: "lg",
                autocomplete: "false",
                placeholder: "Start typing the destinations address..."
              },
              model: {
                value: _vm.searchInput,
                callback: function($$v) {
                  _vm.searchInput = $$v
                },
                expression: "searchInput"
              }
            }),
            _vm._v(" "),
            _vm.searchInput
              ? _c(
                  "button",
                  {
                    staticClass: "clear-btn",
                    on: {
                      click: function($event) {
                        return _vm.reset()
                      }
                    }
                  },
                  [_vm._v("Clear")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.step >= 2
        ? _c("b-card", { staticClass: "mt-3" }, [
            _c("h2", { staticClass: "step-title" }, [
              _vm._v("Product and Delivery")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-inline" }, [
              _c(
                "div",
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.productTypeOptions },
                    model: {
                      value: _vm.productType,
                      callback: function($$v) {
                        _vm.productType = $$v
                      },
                      expression: "productType"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-2" },
                [
                  _c("b-form-select", {
                    attrs: {
                      options: _vm.transportMethodOptions,
                      disabled: !_vm.productType
                    },
                    model: {
                      value: _vm.transportMethod,
                      callback: function($$v) {
                        _vm.transportMethod = $$v
                      },
                      expression: "transportMethod"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-2" },
                [
                  _c("b-form-select", {
                    attrs: {
                      options: _vm.deliveryMethodOptions,
                      disabled: !_vm.transportMethod
                    },
                    model: {
                      value: _vm.deliveryMethod,
                      callback: function($$v) {
                        _vm.deliveryMethod = $$v
                      },
                      expression: "deliveryMethod"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-2" },
                [
                  _c(
                    "b-input-group",
                    {
                      class: { disabled: !_vm.deliveryMethod },
                      attrs: { append: "Tons" }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          readonly:
                            !_vm.productType &&
                            !_vm.transportMethod &&
                            !_vm.deliveryMethod,
                          type: "number",
                          placeholder: "0"
                        },
                        model: {
                          value: _vm.quantity,
                          callback: function($$v) {
                            _vm.quantity = $$v
                          },
                          expression: "quantity"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "ml-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-block",
                    attrs: { disabled: !_vm.canFetchQuote },
                    on: {
                      click: function($event) {
                        return _vm.fetchQuote()
                      }
                    }
                  },
                  [_vm._v("Get Rates")]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-overlay",
        {
          attrs: {
            show: _vm.loading,
            rounded: "sm",
            "spinner-variant": "primary"
          }
        },
        [
          _vm.step >= 3
            ? _c(
                "b-card",
                { staticClass: "mt-3" },
                [
                  _c("h2", { staticClass: "step-title" }, [
                    _vm._v("Rates Available")
                  ]),
                  _vm._v(" "),
                  !_vm.loading
                    ? _c(
                        "b-row",
                        [
                          _c("b-col", [
                            !_vm.rates.length
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "No transport quotes available for the selected address or product."
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.rates
                              ? _c(
                                  "ul",
                                  { staticClass: "transport-rates" },
                                  _vm._l(_vm.rates, function(rate, i) {
                                    return _c(
                                      "li",
                                      {
                                        key: "rate_" + i,
                                        attrs: {
                                          value: i,
                                          name: "rates-radios"
                                        }
                                      },
                                      [
                                        _c(
                                          "header",
                                          {
                                            staticClass:
                                              "rate-header d-flex justify-content-between align-items-center mb-3"
                                          },
                                          [
                                            _c(
                                              "h3",
                                              { staticClass: "rate-name" },
                                              [_vm._v(_vm._s(rate.transporter))]
                                            ),
                                            _vm._v(" "),
                                            rate.fulfillable
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-success badge-sm",
                                                    attrs: {
                                                      variant: "success"
                                                    }
                                                  },
                                                  [_vm._v("In Stock")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !rate.fulfillable
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-danger badge-sm"
                                                  },
                                                  [_vm._v("No Stock")]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "quote-info" }, [
                                          _vm._v(
                                            "\n                Rate Type "
                                          ),
                                          _c("span", [
                                            _vm._v(_vm._s(rate.type))
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "quote-info" }, [
                                          _vm._v("\n                Origin "),
                                          _c("span", [
                                            _vm._v(_vm._s(rate.origin))
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "quote-info" }, [
                                          _vm._v(
                                            "\n                Distance to Destination "
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.warehouseDistances[0]
                                                  .distanceToDestination.text
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "quote-info" }, [
                                          _vm._v(
                                            "\n                Distance to Nearest Town (" +
                                              _vm._s(_vm.nearestTown.name) +
                                              ") "
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.warehouseDistances[0]
                                                  .distanceToNearestTown.text
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("h5", [_vm._v("Freight Cost")]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "price-block mb-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "price-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(rate.freightFormula)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "cost" }, [
                                              _c(
                                                "span",
                                                { staticClass: "unit-cost" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      rate.freight.toLocaleString(
                                                        "en-US",
                                                        {
                                                          style: "currency",
                                                          currency: "USD"
                                                        }
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "d-flex align-content-center justify-content-between"
                                          },
                                          [
                                            _vm._v("Product Cost "),
                                            _c(
                                              "span",
                                              { staticClass: "helper-text" },
                                              [_vm._v("Total includes freight")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(rate.pricing, function(
                                          price,
                                          index
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "price-block"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "price-name" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        price.description
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        price.type === "spot"
                                                          ? "Today's Price"
                                                          : "Month Spread Price"
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cost" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "unit-cost"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          price.price.toLocaleString(
                                                            "en-US",
                                                            {
                                                              style: "currency",
                                                              currency: "USD"
                                                            }
                                                          )
                                                        ) + " T"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "total-cost"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v("Total ")
                                                      ]),
                                                      _vm._v(
                                                        _vm._s(
                                                          price.totalCost.toLocaleString(
                                                            "en-US",
                                                            {
                                                              style: "currency",
                                                              currency: "USD"
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.warehouseDistances
                            ? _c("b-col", [
                                _c("div", { ref: "map", attrs: { id: "map" } })
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09dd329c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09dd329c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quote.vue
// module id = 81fV
// module chunks = 1